<template>
  <ui-content title="Reportes">
    <ui-card>
      <ul class="list-unstyled">
        <li class="mb-3">
          <router-link
            class="btn rounded btn-outline-primary"
            :to="{ name: 'reportes.guias' }"
          >
            Reporte de actividad de guías por fecha
          </router-link>
        </li>
        <li class="mb-3">
          <router-link
            class="btn rounded btn-outline-primary"
            :to="{ name: 'reportes.endoses-fecha' }"
          >
            Reporte de Endoses por fecha
          </router-link>
        </li>
        <li class="mb-3">
          <router-link
            class="btn rounded btn-outline-primary"
            :to="{ name: 'reportes.agencia' }"
          >
            Reporte de Agencia
          </router-link>
        </li>
        <li class="mb-3">
          <router-link
            class="btn rounded btn-outline-primary"
            :to="{ name: 'reportes.movilidad' }"
          >
            Reporte por Movilidad
          </router-link>
        </li>
        <li class="mb-3">
          <router-link
            class="btn rounded btn-outline-primary"
            :to="{ name: 'reportes.liquidaciones' }"
          >
            Reporte de Liquidaciones por Agencia
          </router-link>
        </li>
      </ul>
    </ui-card>
  </ui-content>
</template>
<script>
export default {
  data() {
    return {
      containers: {
        show: {
          modalReporteEndosados: false
        }
      }
    };
  }
};
</script>
